import * as i0 from '@angular/core';
import { input, computed, Component, effect, Directive } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
const _c0 = (a0, a1, a2, a3) => ({
  "fut-skeleton-text": a0,
  ghost: a1,
  "d-inline": a2,
  paragraph: a3
});
function GhostFragmentComponent_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "transloco");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, ctx_r0.ghostText()), " ");
  }
}
function GhostFragmentComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.ghostText(), " ");
  }
}
function GhostFragmentComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, GhostFragmentComponent_Conditional_2_Conditional_0_Template, 2, 3)(1, GhostFragmentComponent_Conditional_2_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.useTranslate() ? 0 : 1);
  }
}
const COMPONENT_STATE = {
  GHOST: 'GHOST',
  LOADING: 'LOADING',
  NONE: 'NONE'
};
function changeState(ghost, loading) {
  if (ghost) {
    return COMPONENT_STATE.GHOST;
  }
  if (loading) {
    return COMPONENT_STATE.LOADING;
  }
  return COMPONENT_STATE.NONE;
}
let GhostFragmentComponent = /*#__PURE__*/(() => {
  class GhostFragmentComponent {
    constructor() {
      this.state = input.required();
      this.text = input();
      this.textMinChar = input();
      this.textMaxChar = input();
      this.paragraph = input();
      this.ghostText = computed(() => {
        const text = this.text();
        const textMinChar = this.textMinChar();
        const textMaxChar = this.textMaxChar();
        const paragraph = this.paragraph();
        if (textMinChar == null || textMaxChar == null) {
          return text || '';
        }
        const textLength = textMinChar === textMaxChar ? textMaxChar : Math.max(textMinChar, Math.random() * textMaxChar);
        if (!paragraph) {
          return 'O'.repeat(textLength);
        }
        let paragraphText = '';
        do {
          const availableLetters = Math.max(textLength - paragraphText.length, 1);
          const wordLength = Math.min(Math.trunc(Math.max(1, Math.random() * 8)), availableLetters);
          const textChunk = '0'.repeat(wordLength);
          paragraphText = [paragraphText, textChunk].join(' ');
        } while (paragraphText.length < textLength);
        return paragraphText;
      }, {});
      this.useTranslate = computed(() => this.textMinChar() == null || this.textMaxChar() == null);
    }
    static {
      this.ɵfac = function GhostFragmentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GhostFragmentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GhostFragmentComponent,
        selectors: [["fut-ghost-fragment"]],
        inputs: {
          state: [1, "state"],
          text: [1, "text"],
          textMinChar: [1, "textMinChar"],
          textMaxChar: [1, "textMaxChar"],
          paragraph: [1, "paragraph"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 7,
        consts: [[1, "w-100"], [1, "ghost-fragment", "fut-skeleton", 3, "ngClass"]],
        template: function GhostFragmentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
            i0.ɵɵtemplate(2, GhostFragmentComponent_Conditional_2_Template, 2, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c0, !!ctx.ghostText(), ctx.state() === "GHOST", ctx.paragraph(), ctx.paragraph()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.ghostText() ? 2 : -1);
          }
        },
        dependencies: [NgClass, TranslocoPipe],
        styles: [".ghost-fragment[_ngcontent-%COMP%]{color:transparent;-webkit-user-select:none;user-select:none;width:min-content;overflow:hidden;min-height:.7em;height:1em;-webkit-box-decoration-break:clone;box-decoration-break:clone}.ghost-fragment.paragraph[_ngcontent-%COMP%]{line-height:1.8em}"]
      });
    }
  }
  return GhostFragmentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GhostStateFragmentDirective = /*#__PURE__*/(() => {
  class GhostStateFragmentDirective {
    constructor(templateRef, viewContainer) {
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
      this.futGhostStateFragment = input();
      this.futGhostStateFragmentText = input();
      this.futGhostStateFragmentTextMinChar = input();
      this.futGhostStateFragmentTextMaxChar = input();
      this.futGhostStateFragmentParagraph = input();
      effect(() => {
        const state = this.futGhostStateFragment();
        this.toggleGhost(state);
      }, {
        allowSignalWrites: true
      });
    }
    ngOnDestroy() {
      this.ghostElement?.destroy();
    }
    toggleGhost(state) {
      const ghost = !!(state && state !== COMPONENT_STATE.NONE);
      this.embeddedViewRef?.destroy();
      this.embeddedViewRef = undefined;
      this.ghostElement?.destroy();
      this.ghostElement = undefined;
      if (ghost) {
        this.ghostElement = this.viewContainer.createComponent(GhostFragmentComponent);
        this.ghostElement.setInput('state', this.futGhostStateFragment());
        this.ghostElement.setInput('text', this.futGhostStateFragmentText());
        this.ghostElement.setInput('textMinChar', this.futGhostStateFragmentTextMinChar());
        this.ghostElement.setInput('textMaxChar', this.futGhostStateFragmentTextMaxChar());
        this.ghostElement.setInput('paragraph', this.futGhostStateFragmentParagraph());
      } else {
        this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
    static {
      this.ɵfac = function GhostStateFragmentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GhostStateFragmentDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: GhostStateFragmentDirective,
        selectors: [["", "futGhostStateFragment", ""]],
        inputs: {
          futGhostStateFragment: [1, "futGhostStateFragment"],
          futGhostStateFragmentText: [1, "futGhostStateFragmentText"],
          futGhostStateFragmentTextMinChar: [1, "futGhostStateFragmentTextMinChar"],
          futGhostStateFragmentTextMaxChar: [1, "futGhostStateFragmentTextMaxChar"],
          futGhostStateFragmentParagraph: [1, "futGhostStateFragmentParagraph"]
        },
        standalone: true
      });
    }
  }
  return GhostStateFragmentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { COMPONENT_STATE, GhostFragmentComponent, GhostStateFragmentDirective, changeState };
